import { render, staticRenderFns } from "./otc.vue?vue&type=template&id=040e13c6&scoped=true&"
import script from "./otc.vue?vue&type=script&lang=js&"
export * from "./otc.vue?vue&type=script&lang=js&"
import style0 from "./otc.vue?vue&type=style&index=0&id=040e13c6&prod&lang=scss&"
import style1 from "./otc.vue?vue&type=style&index=1&id=040e13c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e13c6",
  null
  
)

export default component.exports